/* eslint-disable no-unused-vars */
import { Grid, Typography , CircularProgress} from "@mui/material";
import PConfirm from "../../../components/pos/PConfirm";
import PDialog from "../../../components/pos/PDialog";
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { SyncUtils } from "../../../utils/SyncUtils";

export default function ConfigCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [configTxt, setConfigtxt] = useState("");
  const [configTxtError, setConfigtxtError] = useState("");
  const [legends, setLegends] = useState("");
  const [legendsError, setLegendsError] = useState("");
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showConfigCrudWindow: showConfigCrudWindow,
  };

  useEffect(() => {
    if (origObject) {
      setWindowTitile(origObject.name);
    }
  }, [origObject]);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);
  useEffect(() => {
    if (liveValidation && configTxt === "")
      setConfigtxtError(translate("Configuration is Required"));
    else setConfigtxtError("");
  }, [configTxt]);
  useEffect(() => {
    if (liveValidation && legends === "")
      setLegendsError(translate("Legends is Required"));
    else setLegendsError("");
  }, [legends]);
  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  function showConfigCrudWindow(configId) {
    if (configId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
      setWindowTitile(translate("New Configuration"));
    } else {
      setMode("edit");
      populateConfig(configId);
    }
  }
  async function populateConfig(id) {
    {
      try {
        let { data } = await API.get("/api/v1/config/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate(translate("Not able to retrive Config data from server"))
        );
      }
    }
  }

  function populateData(bean) {
    setName(bean.name);
    setConfigtxt(bean.configTxt);
    setLegends(bean.legends);
    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");
    setConfigtxt("");
    setConfigtxtError("");
    setLegends("");
    setLegendsError("");
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate(translate("Are You Sure")),
      message:
        translate("Are you sure to delete configuration") +
        " :" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/config/" + origObject.id);
        props.showMessage(
          "warning",
          translate("Configuration") +
            " " +
            name +
            " " +
            translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage(
          "error",
          translate("Not able to Delete Configuration")
        );
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/config", payload);
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        props.onRefresh();
        setOpenWindow(false);
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage(
            "error",
            translate("Not able to Save Configuration")
          );
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      if (obj.field === "configTxt") {
        setConfigtxtError(obj.message);
      }
      if (obj.field === "legends") {
        setLegendsError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log(mode);
    saveObject["name"] = name;
    saveObject["configTxt"] = configTxt;
    saveObject["legends"] = legends;
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }
    if (!configTxt || configTxt === "") {
      setConfigtxtError(translate("Configtxt is Required"));
      flag = false;
    }
    if (!legends || legends === "") {
      setLegendsError(translate("Legends is Required"));
      flag = false;
    }
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={9} sm={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td width="20%">
                  <Typography variant="body1">
                    {translate("Name")} <sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </td>
                <td>
                  <PText
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Config Text")}{" "}
                    <sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </td>
                <td>
                  <PText
                    multiline={true}
                    rows={10}
                    maxRows={10}
                    value={configTxt}
                    error={configTxtError}
                    onChange={(e) => setConfigtxt(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Legends")} <sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </td>
                <td>
                  <PText
                    value={legends}
                    error={legendsError}
                    onChange={(e) => setLegends(e.target.value)}
                  ></PText>
                </td>
              </tr>
              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          //onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

{showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
